import { type MouseEvent, useCallback } from 'react'

const INTERACTIVE_SELECTOR = 'button, a, input, label, [role="button"], [role="menuitem"], [role="checkbox"]'

export const hasShiftKey = (event: Event) => 'shiftKey' in event && event.shiftKey === true

export const isInteractiveEventTarget = (target: EventTarget | null) => {
  return target instanceof Element && !!target.closest(INTERACTIVE_SELECTOR)
}

export default function usePreventShiftTextSelection<T extends HTMLElement = HTMLElement>(enabled = true) {
  return useCallback((e: MouseEvent<T>) => {
    if (!enabled || !e.shiftKey || isInteractiveEventTarget(e.target)) {
      return
    }

    e.preventDefault()
  }, [enabled])
}
